// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1bNJ0","overflowing":"ReadFullNote_overflowing__1sHEQ"};